import styled from 'styled-components'
import { Link } from 'react-router-dom'

const StyledStorySetItem = styled(Link)`
  .story-img {
    position: relative;
    width: 100%;
    padding-top: 177%;
    border-radius: 3px;

    .btn {
      z-index: 1;
      position: absolute;
      bottom: 10px;
      right: 10px;
      opacity: 0;
      transition: 0.2s;
      background-color: ${({ theme }) => theme.colors.foreground}80;
      color: ${({ theme }) => theme.colors.background};
      height: 35px;
      width: 35px;
      padding: 0;
      margin: 0;
      border-radius: 3px;
      border: transparent;

      &:hover {
        background-color: ${({ theme }) => theme.colors.foreground}a4;
      }
    }

    .story-count {
      position: absolute;
      pointer-events: none;
      user-select: none;
      right: 8px;
      top: 8px;
      z-index: 1;
      background-color: rgba(0, 0, 0, 0.31);
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 11px;
      color: ${({ theme }) => theme.colors.background};
      padding: 0 5px;
      border-radius: 50rem;

      span {
        top: 1px;
        position: relative;
      }

      svg {
        height: 14px;
        margin-right: 4px;
        opacity: 0.7;
      }
    }

    img {
      position: absolute;
      pointer-events: none;
      user-select: none;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 3px;
    }

    &::after {
      pointer-events: none;
      user-select: none;
      content: '';
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      border-radius: 3px;
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
    }

    &:hover {
      cursor: pointer;

      .btn {
        opacity: 1;
      }
    }
  }

  .story-title {
    font-weight: 600;
    display: block;
    margin-top: 10px;
    font-size: 15px;
    color: ${({ theme }) => theme.colors.gray[800]};
  }
`

export default StyledStorySetItem
